import script from "./CompletionRecommendations.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompletionRecommendations.vue?vue&type=script&setup=true&lang=ts"

import "./CompletionRecommendations.vue?vue&type=style&index=0&id=2632b832&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2632b832"]])

export default __exports__